import { forwardRef } from 'react';
import classNames from 'classnames';
import { withStyles } from '@jpmuitk/theme';

import { ENTER_KEY, SPACE_KEY } from 'Constants/keyCodes';

import { style as linkStyle } from '@jpmuitk/link/style';
import { noButtonStyles, noFocus } from 'styles';

const style = theme => {
  const { root, ...otherStyles } = linkStyle(theme);
  return {
    ...otherStyles,
    root: {
      ...root,
      ...noButtonStyles
    },
    noFocus: {
      ...root,
      ...noButtonStyles,
      ...noFocus
    }
  };
};

const sanitizeForDpa = value =>
  String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

const Button = forwardRef(
  (
    {
      type = 'button',
      noFocus,
      className,
      classes,
      label,
      children,
      description,
      id,
      name,
      ['data-test-id']: dataTestId,
      ['data-dpa-asset-meta-component_id']: dpaComponentId,
      ['data-dpa-event-meta-interaction_name']: dpaInteractionName,
      ...rest
    },
    ref
  ) => {
    const buttonText = label || children;
    const defaultComponentSuffix = sanitizeForDpa(id || dataTestId || name || type || 'as_link');
    const defaultInteractionName = sanitizeForDpa(typeof buttonText === 'string' ? buttonText : 'button_click');
    const analyticsComponentId = dpaComponentId || `c.button_link.${defaultComponentSuffix}`;
    const analyticsInteractionName = dpaInteractionName || defaultInteractionName;

    return (
      <button
        ref={ref}
        type={type}
        id={id}
        name={name}
        data-test-id={dataTestId}
        className={classNames(className, { [classes.root]: !noFocus, [classes.noFocus]: noFocus })}
        aria-description={description}
        data-dpa-asset-meta-component_id={analyticsComponentId}
        data-dpa-event-meta-interaction_name={analyticsInteractionName}
        {...rest}
      >
        {buttonText}
      </button>
    );
  }
);

export default withStyles(style)(Button);
